import { Navigate } from 'react-router-dom';
import OktaSignInWidget from '../../components/atoms/OktaSignInWidget';
import { useOktaAuth } from '@okta/okta-react';

const Login = (props: any) => {
  const { config } = props;
  const { oktaAuth, authState } = useOktaAuth();

  const onSuccess = (tokens: any) => {
    oktaAuth.handleLoginRedirect(tokens);
  };

  const onError = (err: any) => {
    console.log('Sign in error:', err);
  };

  return authState?.isAuthenticated ? (
    <Navigate to={{ pathname: '/' }} />
  ) : (
    <OktaSignInWidget config={config} onSuccess={onSuccess} onError={onError} />
  );
};

export default Login;
